
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cover-letter",
      function () {
        return require("private-next-pages/cover-letter/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cover-letter"])
      });
    }
  